import { Card, Col, Row } from "antd";
import IdentifierType from "common/IdentifierType";
import { formatDateTime } from "helpers/formatDate";

const InfoCertOrg = (props) => {
  const { isOld, oldInfo, infoCertNew, title } = props;

  const getIdentityLabel = (identityType) => {
    const identifierList = IdentifierType.TO_CHUC;
    const foundItem = identifierList.find(item => item.value === identityType);
    return foundItem ? foundItem.label : "Không xác định"; // Default value if not found
  };


  return (
    <>
      <Card
        title={
          title
            ? title
            : isOld
            ? "Thông tin chứng thư số hiện tại"
            : "Thông tin chứng thư số sau cấp bù"
        }
        className="break-word  p-0 cs-card-border"
      >
        
        <Row className="certificate-item">
          <Col span={8}>Tên tổ chức:</Col>
          <Col span={16} className="text-fw-500">
            {oldInfo.name}
          </Col>
        </Row>
        <Row className="certificate-item">
          <Col span={8}>
          {getIdentityLabel(oldInfo.identityType)}
          :</Col>
          <Col span={16} className="text-fw-500">
            {oldInfo.code}
          </Col>
        </Row>
        {!title && (
          <Row className="certificate-item">
            <Col span={8}>Ngày hết hạn DV:</Col>
            <Col span={16} className="text-fw-500">
              {formatDateTime(oldInfo.certificateEnd)}
            </Col>
          </Row>
        )}

        {isOld ? (
          <Row className="certificate-item">
            <Col span={8}>Serial chứng thư số:</Col>
            <Col span={16} className="text-fw-500">
              {oldInfo.serinumberCert}
            </Col>
          </Row>
        ) : (
          <></>
        )}

        {infoCertNew}
      </Card>
    </>
  );
};
export default InfoCertOrg;
